import { create } from 'zustand';

export const useWhatsNewModalStore = create((set) => ({
  isOpen: false,
  setIsOpen: (isOpen) => set({ isOpen }),
}));
